// ══════════════════════════════════════════════════════════════════════════════
// SELDOR — Navigation Modules
// The 4 pillars + Financial Radar + Data Mapping + Admin sections
// ══════════════════════════════════════════════════════════════════════════════

import {
  BarChart3, Lightbulb, Brain, Map, Radar, Link2,
  Activity, Users, Building2, Bell, Crown
} from 'lucide-react';

// ─── Client navigation ────────────────────────────────────────────────────
export const CLIENT_MODULES = [
  { key: 'dashboard', icon: BarChart3, translationKey: 'dashboard', featureKey: 'dashboard', route: '/dashboard' },
  { key: 'insight_hub', icon: Lightbulb, translationKey: 'insightHub', featureKey: 'insight_hub', route: '/insights' },
  { key: 'market_intel', icon: Brain, translationKey: 'marketIntel', featureKey: 'market_intel', route: '/market' },
  { key: 'growth_roadmap', icon: Map, translationKey: 'growthRoadmap', featureKey: 'growth_roadmap', route: '/growth' },
  { key: 'financial_radar', icon: Radar, translationKey: 'financialRadar', featureKey: 'financial_radar', route: '/radar' },
  { key: 'data_mapping', icon: Link2, translationKey: 'dataMapping', featureKey: 'data_mapping', route: '/mapping' }
];

// ─── Admin navigation ────────────────────────────────────────────────────
export const ADMIN_MODULES = [
  { key: 'command_center', icon: Activity, translationKey: 'commandCenter', route: '/admin' },
  { key: 'user_management', icon: Users, translationKey: 'userManagement', route: '/admin/users' },
  { key: 'tenant_management', icon: Building2, translationKey: 'tenantManagement', route: '/admin/tenants' },
  { key: 'broadcast', icon: Bell, translationKey: 'broadcast', route: '/admin/broadcast' },
  { key: 'customer_override', icon: Crown, translationKey: 'customerOverride', route: '/admin/override' }
];

// ─── Subscription Tiers ─────────────────────────────────────────────────
export const SUBSCRIPTION_TIERS = {
  basic: {
    priceMonthly: 299,
    allowedModules: ['dashboard', 'insight_hub']
  },
  growth: {
    priceMonthly: 599,
    allowedModules: ['dashboard', 'insight_hub', 'market_intel', 'financial_radar', 'data_mapping']
  },
  enterprise: {
    priceMonthly: 1499,
    allowedModules: ['dashboard', 'insight_hub', 'market_intel', 'growth_roadmap', 'financial_radar', 'data_mapping']
  }
};
